import React, { ReactElement } from 'react';
import type { Route } from 'next';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { cards } from 'sections/Benefits/data';
import Card from 'components/Card';
import styles from 'sections/Benefits/components/SectionCards/SectionCards.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  const cardItems = cards.map((card) => {
    return (
      <Card className={cn('card')} key={card.icon}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__title-box')}>
            <div className={cn('card__icon')}>
              <img src={`/images/pages/Benefits/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('card__title')}>{card.title}</h3>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
        {card.link
          ?
          <Card.Footer className={cn('card__buttons')}>
            <Link className={cn('card__button-learn')} href={card.link as Route}>
              Learn more
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link>
          </Card.Footer>
          :
          null
        }
      </Card>
    );
  });

  return (
    <section className={cn('cards')} id="cards">
      <div className={cn('container')}>
        <div className={cn('cards__title-box')}>
          <h2 className={cn('cards__title')}>
            <span>Empowering Freight Forwarders</span>
            <span>with Comprehensive Membership Benefits</span>
          </h2>
          <p className={cn('cards__title-description')}>
            Explore the cornerstone advantages that redefine logistics success,
            designed exclusively for freight forwarders by DFA.
          </p>
        </div>
        <ul className={cn('cards__list')}>
          {cardItems}
        </ul>
      </div>
    </section>
  );
}

export default SectionPitch;